import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infor-cookies',
  templateUrl: './infor-cookies.component.html',
  styleUrls: ['./infor-cookies.component.css']
})
export class InfoCookiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
